module.exports = __webpack_public_path__ + "static/img/menu4.2f722a17.png";